var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgForwardArrowCircled = function SvgForwardArrowCircled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "currentColor",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5774 16.0774C23.252 16.4028 23.252 16.9305 23.5774 17.2559L25.4882 19.1667H12.5C12.0398 19.1667 11.6667 19.5398 11.6667 20C11.6667 20.4602 12.0398 20.8333 12.5 20.8333H25.4882L23.5774 22.7441C23.252 23.0695 23.252 23.5972 23.5774 23.9226C23.9028 24.248 24.4305 24.248 24.7559 23.9226L28.0889 20.5896C28.089 20.5895 28.0891 20.5894 28.0893 20.5893C28.0898 20.5887 28.0904 20.5881 28.091 20.5875C28.17 20.508 28.2297 20.4165 28.2701 20.319C28.3108 20.2207 28.3333 20.113 28.3333 20C28.3333 19.887 28.3108 19.7793 28.2701 19.681C28.2294 19.5827 28.1691 19.4906 28.0893 19.4107L24.7559 16.0774C24.4305 15.752 23.9028 15.752 23.5774 16.0774Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgForwardArrowCircled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ForwardArrowCircled.bcb30399106df8d2d61ffdd8232a7231.svg";